import React from 'react';
import {CgSpinner} from 'react-icons/cg';

interface LoadingProps {
    label?: string;
    className?: string;
}

const Loading: React.FC<LoadingProps> = ({label = '', className,}) => {
    return (
        <div className={`${className} flex flex-col items-center justify-center gap-2`}>
            <div className='text-lg font-semibold mb-1'>{label}</div>
            <CgSpinner className="animate-spin  text-mcia_orange "/>
        </div>
    );
};

export default Loading;